import { FileInfo } from "@progress/kendo-angular-upload";

export interface MediaItemInfo extends FileInfo {
  type: MediaType;
  id: number;
  uri: any;
  mediaFileTitle: string;
  mediaFileTags: string;
  oServerData?: any
}

export enum MediaType {
  Unsupported = -1,
  Audio = 1,  
  Document = 2,
  Image = 3,
  Video = 4
}

export const arrAllowedImageTypes: string[] = [".jpg", ".jpeg", ".png", ".bmp", ".gif", ".tif", ".tiff"];
export const arrAllowedVideoTypes: string[] = [".mp4", ".mov", ".webm", ".flv", ".mkv", ".ogg", ".3gp"];
export const arrAllowedDocTypes: string[] = [".doc", ".docx", ".ppt", ".pptx", ".xlx", ".xlsx", ".pdf", ".txt", ".csv"];
export const arrAllowedAudioType: string[] = [".mp3", ".wav", ".mpeg", ".aac", ".amr", ".m4a", ".wma", ".flac", ".aiff"];
